import * as types from '../types.js';

export default {

	html: `
		<style>
			#inventory #company_id		{ width: 100%; }
			#inventory #warehouse_id	{ width: 100%; }
			#inventory #name			{ width: 100%; }
		</style>
		<form id="inventory" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="title">
				Iniciar Inventário
			</div>
			<div class="mtl fsb">
				<label title="Empresa a inventariar">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Armazém a inventariar">Armazém<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome do inventário">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Iniciar</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#inventory',
		init(formset)
		{
			formset.form.eraseValues();
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#name' }, types: [types.name()] },
	]

};

